module.exports = __webpack_public_path__ + "img/MADDEN23-banner_day5.255e1e89.png";